
define('modules/application/widgets/linkery',[
  "app",

  // Libs
  "backbone"
],

function(app, Backbone) {

  var linkeryView = Backbone.View.extend({
    tagName    : "section",
    className  : "linkery",
    template   : "application/widgets/linkery",
    serialize  : function() {return {model : this.model, app : BticinoS4B.Instances.Models.ApplicationModel};},
    initialize : function() {
      this.model = new Backbone.Model();
    }
  });
  var linkery = {
    View : linkeryView
  };

  return linkery;

});